import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { BaseFieldControlComponent } from '@d-components/base-field-control/base-field-control';
import { BaseLabelComponent } from '@d-components/label/label.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { TranslateModule } from '@ngx-translate/core';
import { OnlyNumberDirective } from 'app/core/directives/only-number.directive';
import { OnlyNumberSpaceAndDashDirective } from 'app/core/directives/only-number-space-and-dash.directive';

@Component({
  selector: 'app-base-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    CommonModule,
    BaseLabelComponent,
    InputNumberModule,
    TranslateModule,
    InputSwitchModule,
    OnlyNumberDirective,
    OnlyNumberSpaceAndDashDirective,
  ],
})
export class BaseInputComponent
  extends BaseFieldControlComponent
  implements OnInit
{
  @Input() mode:
    | 'text'
    | 'number'
    | 'password'
    | 'switch'
    | 'label-text'
    | 'contact' = 'text';
  @Input() iconUrl!: string;
  @Input() leftIconUrl!: string;
  @Input() onBlurFunction: any;
  @Input() onlyNumber: boolean = false;
  @Input() maxLength = 255;
  @Input() prefix: string = '';
  @Input() suffix: string = '';
  @Input() min!: number;
  @Input() max!: number;
  @Input() minFractionDigits: number = 2;
  @Input() maxFractionDigits: number = 2;
  @Input() useGrouping: boolean = true;
  @Input() content!: string;
  @Input() descriptionMessage: string = '';
  @Input() labelTextStyle: string = '';
  @Input() currency: string = '';

  @ViewChild('prefix_content', { static: true })
  prefix_content!: ElementRef<HTMLDivElement>;

  paddingForPrefix = 10;

  ngOnInit() {
    if (this.mode === 'number') {
      this.fieldControl.setValue(this.fieldControl.value ?? undefined, {
        emitEvent: false,
      });
    }
    this.paddingForPrefix = this.prefix_content?.nativeElement.clientWidth;
  }

  onBlur() {
    if (!!this.onBlurFunction) return this.onBlurFunction();
  }
}
